/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import BookFileDto from './BookFileDto';
import BookSelectedFileDto from './BookSelectedFileDto';
import CategoryDto from './CategoryDto';
import LanguageDto from './LanguageDto';
import OrganizationObjectDto from './OrganizationObjectDto';
import ProductTypeDto from './ProductTypeDto';

/**
 * The BookDto model module.
 * @module model/BookDto
 * @version v1.0.0
 */
class BookDto {
    /**
     * Constructs a new <code>BookDto</code>.
     * @alias module:model/BookDto
     */
    constructor() { 
        
        BookDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>BookDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/BookDto} obj Optional instance to populate.
     * @return {module:model/BookDto} The populated <code>BookDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new BookDto();

            if (data.hasOwnProperty('author')) {
                obj['author'] = ApiClient.convertToType(data['author'], 'String');
            }
            if (data.hasOwnProperty('bookComment')) {
                obj['bookComment'] = ApiClient.convertToType(data['bookComment'], 'String');
            }
            if (data.hasOwnProperty('bookIsbn')) {
                obj['bookIsbn'] = ApiClient.convertToType(data['bookIsbn'], 'String');
            }
            if (data.hasOwnProperty('categories')) {
                obj['categories'] = ApiClient.convertToType(data['categories'], [CategoryDto]);
            }
            if (data.hasOwnProperty('ctsid')) {
                obj['ctsid'] = ApiClient.convertToType(data['ctsid'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
            if (data.hasOwnProperty('inventory')) {
                obj['inventory'] = ApiClient.convertToType(data['inventory'], 'Number');
            }
            if (data.hasOwnProperty('languages')) {
                obj['languages'] = ApiClient.convertToType(data['languages'], [LanguageDto]);
            }
            if (data.hasOwnProperty('lastUpdate')) {
                obj['lastUpdate'] = ApiClient.convertToType(data['lastUpdate'], 'Number');
            }
            if (data.hasOwnProperty('mainBookId')) {
                obj['mainBookId'] = ApiClient.convertToType(data['mainBookId'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('organization')) {
                obj['organization'] = OrganizationObjectDto.constructFromObject(data['organization']);
            }
            if (data.hasOwnProperty('originalPrice')) {
                obj['originalPrice'] = ApiClient.convertToType(data['originalPrice'], 'Number');
            }
            if (data.hasOwnProperty('price')) {
                obj['price'] = ApiClient.convertToType(data['price'], 'Number');
            }
            if (data.hasOwnProperty('productType')) {
                obj['productType'] = ProductTypeDto.constructFromObject(data['productType']);
            }
            if (data.hasOwnProperty('publishDate')) {
                obj['publishDate'] = ApiClient.convertToType(data['publishDate'], 'Number');
            }
            if (data.hasOwnProperty('root')) {
                obj['root'] = ApiClient.convertToType(data['root'], 'Boolean');
            }
            if (data.hasOwnProperty('selectedFiles')) {
                obj['selectedFiles'] = BookSelectedFileDto.constructFromObject(data['selectedFiles']);
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'String');
            }
            if (data.hasOwnProperty('translator')) {
                obj['translator'] = ApiClient.convertToType(data['translator'], 'String');
            }
            if (data.hasOwnProperty('uploadedFiles')) {
                obj['uploadedFiles'] = BookFileDto.constructFromObject(data['uploadedFiles']);
            }
            if (data.hasOwnProperty('version')) {
                obj['version'] = ApiClient.convertToType(data['version'], 'String');
            }
        }
        return obj;
    }


}

/**
 * 作者
 * @member {String} author
 */
BookDto.prototype['author'] = undefined;

/**
 * 書評
 * @member {String} bookComment
 */
BookDto.prototype['bookComment'] = undefined;

/**
 * ISBN/產品編號
 * @member {String} bookIsbn
 */
BookDto.prototype['bookIsbn'] = undefined;

/**
 * 分類
 * @member {Array.<module:model/CategoryDto>} categories
 */
BookDto.prototype['categories'] = undefined;

/**
 * @member {String} ctsid
 */
BookDto.prototype['ctsid'] = undefined;

/**
 * 產品簡介
 * @member {String} description
 */
BookDto.prototype['description'] = undefined;

/**
 * book id
 * @member {String} id
 */
BookDto.prototype['id'] = undefined;

/**
 * inventory
 * @member {Number} inventory
 */
BookDto.prototype['inventory'] = undefined;

/**
 * languages
 * @member {Array.<module:model/LanguageDto>} languages
 */
BookDto.prototype['languages'] = undefined;

/**
 * last update
 * @member {Number} lastUpdate
 */
BookDto.prototype['lastUpdate'] = undefined;

/**
 * mainBookId
 * @member {String} mainBookId
 */
BookDto.prototype['mainBookId'] = undefined;

/**
 * 產品名稱
 * @member {String} name
 */
BookDto.prototype['name'] = undefined;

/**
 * @member {module:model/OrganizationObjectDto} organization
 */
BookDto.prototype['organization'] = undefined;

/**
 * 原價
 * @member {Number} originalPrice
 */
BookDto.prototype['originalPrice'] = undefined;

/**
 * 售價
 * @member {Number} price
 */
BookDto.prototype['price'] = undefined;

/**
 * @member {module:model/ProductTypeDto} productType
 */
BookDto.prototype['productType'] = undefined;

/**
 * 出版日期
 * @member {Number} publishDate
 */
BookDto.prototype['publishDate'] = undefined;

/**
 * @member {Boolean} root
 */
BookDto.prototype['root'] = undefined;

/**
 * @member {module:model/BookSelectedFileDto} selectedFiles
 */
BookDto.prototype['selectedFiles'] = undefined;

/**
 * 狀態
 * @member {module:model/BookDto.StatusEnum} status
 */
BookDto.prototype['status'] = undefined;

/**
 * 譯者
 * @member {String} translator
 */
BookDto.prototype['translator'] = undefined;

/**
 * @member {module:model/BookFileDto} uploadedFiles
 */
BookDto.prototype['uploadedFiles'] = undefined;

/**
 * version
 * @member {String} version
 */
BookDto.prototype['version'] = undefined;





/**
 * Allowed values for the <code>status</code> property.
 * @enum {String}
 * @readonly
 */
BookDto['StatusEnum'] = {

    /**
     * value: "APPLY_UNAVAILABLE"
     * @const
     */
    "APPLY_UNAVAILABLE": "APPLY_UNAVAILABLE",

    /**
     * value: "APPROVED"
     * @const
     */
    "APPROVED": "APPROVED",

    /**
     * value: "AVAILABLE"
     * @const
     */
    "AVAILABLE": "AVAILABLE",

    /**
     * value: "REJECTED"
     * @const
     */
    "REJECTED": "REJECTED",

    /**
     * value: "SUBMITTED"
     * @const
     */
    "SUBMITTED": "SUBMITTED",

    /**
     * value: "TEMP"
     * @const
     */
    "TEMP": "TEMP",

    /**
     * value: "UNAVAILABLE"
     * @const
     */
    "UNAVAILABLE": "UNAVAILABLE"
};



export default BookDto;

